class Resize {
    constructor() {
      this.callbacks = []
      this.running = false
    }

    resize() {
      if (!this.running) {
        this.running = true;

        if (window.requestAnimationFrame) {
          window.requestAnimationFrame(this.runCallbacks.bind(this));
        } else {
          setTimeout(this.runCallbacks, 66);
        }
      }
    }

    runCallbacks() {
      this.callbacks.forEach(function (callback) {
        callback();
      });
      this.running = false;
    }

    addCallback(callback){
      if (callback) {
        this.callbacks.push(callback);
      }
    }

    add(callback) {
      if (!this.callbacks.length) {
          window.addEventListener('resize', this.resize.bind(this));
      }
      this.addCallback(callback);
    }
  }

  export let resize = new Resize();